"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { useSession } from "next-auth/react"
import { MetkaWordmark } from "@/components/brand/metka-wordmark"

const NAV = [
  { href: "#features", label: "Возможности" },
  { href: "#pricing", label: "Тарифы" },
  { href: "#faq", label: "Вопросы" },
  { href: "/about", label: "О сервисе" },
  { href: "/blog", label: "Блог" },
]

export function Header() {
  const { status } = useSession()
  const isAuthed = status === "authenticated"
  const pathname = usePathname()
  // Hash-links ведут на секции лендинга — если открыта не главная, нужно вернуть на `/` + якорь.
  const resolveHref = (href: string) =>
    href.startsWith("#") && pathname !== "/" ? `/${href}` : href

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-[rgba(11,16,32,0.10)]">
      <div className="mx-auto max-w-[1400px] flex items-center justify-between px-6 py-5 lg:px-14">
        <Link href="/" className="shrink-0" aria-label="МЕТКА — на главную">
          <MetkaWordmark size={22} animated />
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-[14px]">
          {NAV.map((n) => {
            // Активный пункт только для route-ссылок (не хеш-якорей лендинга).
            const isActive =
              !n.href.startsWith("#") &&
              (n.href === "/"
                ? pathname === "/"
                : pathname === n.href || pathname.startsWith(`${n.href}/`))
            return (
              <a
                key={n.href}
                href={resolveHref(n.href)}
                aria-current={isActive ? "page" : undefined}
                className={
                  isActive
                    ? "text-[#0b1020] font-semibold border-b-2 border-[#ea580c] pb-[2px] transition-colors"
                    : "text-[#0b1020]/80 hover:text-[#0b1020] border-b-2 border-transparent pb-[2px] transition-colors"
                }
              >
                {n.label}
              </a>
            )
          })}
        </nav>

        <div className="flex items-center gap-3">
          {isAuthed ? (
            <Link
              href="/lk"
              className="inline-block bg-[#0b1020] text-[#f4f4f5] text-[13px] font-semibold px-3 sm:px-4 py-[9px] rounded-[4px] hover:opacity-92 transition-opacity whitespace-nowrap"
            >
              <span className="sm:hidden">Кабинет</span>
              <span className="hidden sm:inline">В личный кабинет</span>
            </Link>
          ) : (
            <>
              <Link
                href="/auth/signin"
                className="text-[14px] text-[#0b1020]/70 hover:text-[#0b1020] transition-colors px-2 py-1"
              >
                Войти
              </Link>
              <Link
                href="/auth/signup"
                className="hidden sm:inline-block bg-[#0b1020] text-[#f4f4f5] text-[13px] font-semibold px-4 py-[9px] rounded-[4px] hover:opacity-92 transition-opacity"
              >
                Регистрация
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
